// 3rd party
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

// models
import { ContactCustomer } from 'app/shared/models/contact-customer.model';
import { Theme } from 'app/shared/models/theme';

@Injectable()
export class AuthService {

  currentContact = new EventEmitter<ContactCustomer>();
  showApp = new EventEmitter<boolean>();

  constructor(
    private http: Http,
    private router: Router
  ) { }

  checkAccess() {
    let contactCustomer: ContactCustomer = JSON.parse(localStorage.getItem('currentContact'));
    if (contactCustomer && contactCustomer.Identifier) {
      this.currentContact.emit(contactCustomer);
      this.showApp.emit(true);
    }
  }

  getTheme(domain?: string): Observable<any> {
    return this.http
      .get('auth/theme?domain=' + domain)
      .map((res) => res.text())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getSiteLogo(domain?: string): Observable<any> {
    return this.http
      .get('auth/imagesite?domain=' + domain)
      .map((res) => res.text())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getLoginLogo(domain?: string): Observable<any> {
    return this.http
      .get('auth/imagelogin?domain=' + domain)
      .map((res) => res.text())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getPermissionCustomLogin(domain?: string): Observable<any> {
    return this.http
      .get('auth/webviewperm?domain=' + domain)
      .map((res) => res.text())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  login(login: string, password: string, stayConnected: boolean = false): Promise<ContactCustomer> {
    let body = JSON.stringify({ login: login, password: password, stayConnected: stayConnected });
    let options = new RequestOptions();
    options.headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http
      .post('customers/contacts/login', body, options)
      .toPromise()
      .then(res => {
        let data = res.json();
        let contactCustomer = data.currentContact as ContactCustomer;
        let systemConfiguration = data.systemConfiguration;
        let hasAssayAccess = data.hasAssayAccess || false;
        let usePdfJsViewer = data.usePdfJsViewer || false;
        if (systemConfiguration) {
          if (systemConfiguration.InstrumentTagName) {
            localStorage.setItem('instrumentTagName', systemConfiguration.InstrumentTagName);
          } else {
            localStorage.removeItem('instrumentTagName');
          }
          if (systemConfiguration.NewCalibrationTagName) {
            localStorage.setItem('newCalibrationTagName', systemConfiguration.NewCalibrationTagName);
          } else {
            localStorage.removeItem('newCalibrationTagName');
          }
        }
        if (contactCustomer && contactCustomer.Identifier) {
          localStorage.setItem('currentContact', JSON.stringify(contactCustomer));
          localStorage.setItem('token', contactCustomer.Token.access_token);
          localStorage.setItem('preferedLang', contactCustomer.PreferedLanguage);
          localStorage.setItem('lastUser', login);

          // Acesso ao modulo de ensaios
          if (hasAssayAccess)
            localStorage.setItem('assayAccess', hasAssayAccess);
          else
            localStorage.removeItem('assayAccess');

          if (usePdfJsViewer)
            localStorage.setItem('usePdfJsViewer', usePdfJsViewer);
          else
            localStorage.removeItem('usePdfJsViewer');

          this.currentContact.emit(contactCustomer);
          this.showApp.emit(true);
        } else {
          this.currentContact.emit(contactCustomer);
          this.showApp.emit(false);
        }
        return contactCustomer;
      })
      .catch((error: any) => Promise.reject(error));
  }

  logoff() {
    localStorage.removeItem('currentContact');
    localStorage.removeItem('token');
    let contactCustomer: ContactCustomer = new ContactCustomer();
    contactCustomer.Email = localStorage.getItem('lastLogin');
    this.currentContact.emit(contactCustomer);
    this.showApp.emit(false);
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/auth.service.ts